import { BaseComponent } from '../../types';
import { FeatureCard } from './FeatureCard';
import { OperationsContainer } from './OperationsContainer';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

interface OperationsSectionProps extends BaseComponent {}

export function OperationsSection({ className }: OperationsSectionProps) {
  const { ref: titleRef, isVisible: titleVisible } = useScrollAnimation();
  const { ref: cardsRef, isVisible: cardsVisible } = useScrollAnimation();
  const { ref: containerRef, isVisible: containerVisible } =
    useScrollAnimation();

  return (
    <>
      <style>{`
        @media (min-width: 1024px) {
          .operations-cards-container {
            max-width: 75rem !important;
          }
        }
      `}</style>
      <section
        className={`w-full flex flex-col justify-center items-center py-12 px-6 md:px-24 ${className || ''}`}
        style={{
          minHeight: '600px',
          gap: '28px',
          background:
            'radial-gradient(79% 66% at 100% 100%, #55E1DD 0%, #00649E 23.91%, #020816 100%)',
        }}
      >
        <h2
          ref={titleRef}
          className={`transition-all duration-700 ease-out ${
            titleVisible
              ? 'opacity-100 transform translate-y-0'
              : 'opacity-0 transform translate-y-8'
          }`}
          style={{
            color: '#FFF',
            textAlign: 'center',
            fontFamily: 'Inter',
            fontSize: '48px',
            fontStyle: 'normal',
            fontWeight: '700',
            lineHeight: 'normal',
          }}
        >
          Tüm Operasyonlarınızı Tek Bir Merkezden
          <br />
          <span style={{ display: 'block', textAlign: 'center' }}>
            Kolayca Yönetin
          </span>
        </h2>

        {/* Feature Cards */}
        <div
          ref={cardsRef}
          className={`operations-cards-container flex flex-wrap justify-center gap-6 w-full max-w-none lg:mx-auto transition-all duration-700 ease-out ${
            cardsVisible
              ? 'opacity-100 transform translate-y-0'
              : 'opacity-0 transform translate-y-8'
          }`}
        >
          <FeatureCard
            icon="papper.svg"
            title="Satıcı ve Ürün Yönetimi"
            description="Satıcı onboarding süreçlerini yönetin, ürün kataloglarını merkezi olarak kontrol edin ve tüm içerik akışını tek panelden organize edin."
          />
          <FeatureCard
            icon="rocket.svg"
            title="Sipariş ve Ödeme Süreçleri"
            description="Sipariş akışlarını yönetin, ödeme ve komisyon yapılarını esnek şekilde kurgulayın ve tüm süreçleri güvenli şekilde takip edin."
          />
          <FeatureCard
            icon="message.svg"
            title="Entegrasyon ve API Altyapısı"
            description="ERP, kargo ve ödeme sistemleri ile kolayca entegre olun. Esnek API altyapısı sayesinde mevcut sistemlerinizle uyumlu çalışın."
          />
        </div>

        {/* Operations Container */}
        <div
          ref={containerRef}
          className={`transition-all duration-700 ease-out ${
            containerVisible
              ? 'opacity-100 transform translate-y-0'
              : 'opacity-0 transform translate-y-8'
          }`}
        >
          <OperationsContainer />
        </div>
      </section>
    </>
  );
}
